(function (Drupal, $, settings) {
  Drupal.behaviors.cart = {
    attach: function attach() {
      const data = localStorage.getItem('reduxStore')
      if (data && data.length) {
        const json = Flatted.parse(data);
        const appState = json.appState;
        if (appState.basket && appState.basket.id) {
          fetch(settings.nomnom.apiUrl + '/baskets/' + appState.basket.id)
            .then(res => res.json())
            .then(res => {
              const cartProductsCount = res.products.length;
              if (cartProductsCount > 0) {
                $('.cart-items-count').text(cartProductsCount - 1).removeClass('empty');
              }
            }).catch(e => {});

        }
      }
    }
  }
})(Drupal, jQuery, drupalSettings);
